/**
 * Builds the auth UI login path. Always includes isLegacy=true.
 * Accepts a raw (unencoded) path as backTo — encoding is handled internally.
 */
export const buildLoginPath = (backTo = "") => {
  const params = new URLSearchParams({ isLegacy: "true" });
  if (backTo) {
    params.set("backTo", backTo);
  }

  return `/login?${params.toString()}`;
};
